import { useQuery } from '@tanstack/react-query';
import { getProjects, type ProjectTile } from '../api/projects';

/** Lists the sub-projects the current user can see. One call per landing-page render. */
export function useProjects() {
  return useQuery<ProjectTile[]>({
    queryKey: ['projects'],
    queryFn: getProjects,
    staleTime: 60_000,
    retry: false,
  });
}
